export const bibliographyDirective = {
    name: 'bibliography',
    options: {
        filter: {
            type: String,
        },
    },
    run(data) {
        var _a;
        return [
            {
                type: 'bibliography',
                filter: (_a = data.options) === null || _a === void 0 ? void 0 : _a.filter,
            },
        ];
    },
};
